import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/triangle.tsx
var Triangle = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M17.252 19.25H6.74803C5.26465 19.25 4.29985 17.6884 4.96324 16.3611L10.2152 5.85345C10.9506 4.38218 13.0494 4.38218 13.7848 5.85345L19.0368 16.3611C19.7001 17.6884 18.7354 19.25 17.252 19.25Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M4.29233 16.0258C3.37989 17.8513 4.70668 20 6.74799 20H17.2519C19.2932 20 20.62 17.8513 19.7076 16.0258L14.4556 5.51814C13.4439 3.49395 10.556 3.49396 9.54431 5.51814L4.29233 16.0258Z",
		fill: "currentColor"
	})
});
//#endregion
export { Triangle };
